export const ProposalRoute = {
  PROPOSALS: '/proposals',
  PROPOSAL_CREATE: '/proposals/new',
  PROPOSAL_RENEWAL: '/proposals/renew',
  PROPOSAL_DETAILS: '/proposals/:id',
};

export const ProposalName = {
  PROPOSALS: 'proposals',
  PROPOSAL_CREATE: 'proposal-create',
  PROPOSAL_RENEWAL: 'proposal-renewal',
  PROPOSAL_DETAILS: 'proposal-details',
};

export const ProposalStatus = {
  STATUS_DRAFT: 'Draft',
  STATUS_PENDING_APPROVAL: 'Pending Approval',
  STATUS_CLOSED_LOST: 'Closed-Lost',
  STATUS_APPROVED: 'Approved',
  STATUS_COMPLETED: 'Completed',
};

export const ProposalUpdateActions = {
  ACTION_SUBMIT: 'submit',
  ACTION_APPROVE: 'approve',
  ACTION_REJECT: 'reject',
  ACTION_CONVERT_TO_ORDER: 'convert_to_order',
};

export const ProposalSteps = {
  STEP_1: 'step1',
  STEP_2: 'step2',
  STEP_3: 'step3',
};

export const ProposalFieldNames = Object.freeze({
  NAME: 'name',
  CLIENT_ID: 'client_id',
  CLIENT_VERTICAL: 'client_vertical',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  TOTAL_BUDGET: 'total_budget',
  OBJECTIVE: 'objective',
});

export const AudienceFieldNames = Object.freeze({
  AUDIENCE_GENDER: 'audience_gender',
  AUDIENCE_INCOME_LEVEL: 'audience_income_level',
  AUDIENCE_AGE_RANGE: 'audience_age_range',
  GEOGRAPHIC_LOCATION: 'geographic_location',
});

export const ProposalListColumns = Object.freeze({
  ACTIONS: 'actions',
  CLIENT: 'client',
  NAME: ProposalFieldNames.NAME,
  TOTAL_BUDGET: ProposalFieldNames.TOTAL_BUDGET,
  START_DATE: ProposalFieldNames.START_DATE,
  SALESPERSON: 'salesperson',
  STATUS: 'status',
});

export const ProposalProductFieldNames = Object.freeze({
  NAME: ProposalFieldNames.NAME,
  START_DATE: ProposalFieldNames.START_DATE,
  END_DATE: ProposalFieldNames.END_DATE,
  TOTAL_BUDGET: ProposalFieldNames.TOTAL_BUDGET,
  WHOLESALE_CPM: 'wholesale_cpm',
  MARKUP_PERCENT: 'markup_percent',
  PROPOSAL_RETAIL_CPM: 'proposal_retail_cpm',
});

export const RequiredProposalFields = {
  NAME: ProposalFieldNames.NAME,
  CLIENT_ID: ProposalFieldNames.CLIENT_ID,
  START_DATE: ProposalFieldNames.START_DATE,
  END_DATE: ProposalFieldNames.END_DATE,
  TOTAL_BUDGET: ProposalFieldNames.TOTAL_BUDGET,
  OBJECTIVE: ProposalFieldNames.OBJECTIVE,
};

export const RequiredProductProposalFields = {
  NAME: ProposalProductFieldNames.NAME,
  START_DATE: ProposalProductFieldNames.START_DATE,
  END_DATE: ProposalProductFieldNames.END_DATE,
  TOTAL_BUDGET: ProposalProductFieldNames.TOTAL_BUDGET,
  WHOLESALE_CPM: ProposalProductFieldNames.WHOLESALE_CPM,
  MARKUP_PERCENT: ProposalProductFieldNames.MARKUP_PERCENT,
  PROPOSAL_RETAIL_CPM: ProposalProductFieldNames.PROPOSAL_RETAIL_CPM,
};

export const RejectionReasonLabels = {
  budget_constraints: 'Budget Constraints',
  timeline_issue: "Timeline Doesn't Work",
  wrong_audience_target: 'Wrong Audience Targeting',
  client_changed_direction: 'Client Changed Direction',
  product_mix_not_suitable: 'Product Mix Not Suitable',
  other: 'Other',
};

export const CostBasisBlockingFields = [
  ProposalProductFieldNames.TOTAL_BUDGET,
  ProposalProductFieldNames.WHOLESALE_CPM,
  ProposalProductFieldNames.MARKUP_PERCENT,
  ProposalProductFieldNames.PROPOSAL_RETAIL_CPM,
];

export const FlightRecommendationFields = [
  ProposalFieldNames.CLIENT_ID,
  ProposalFieldNames.CLIENT_VERTICAL,
  ProposalFieldNames.OBJECTIVE,
  ProposalFieldNames.TOTAL_BUDGET,
  ProposalFieldNames.START_DATE,
  ProposalFieldNames.END_DATE,
];

export const ChannelClassification = {
  TRADITIONAL: 'traditional',
  DIGITAL: 'digital',
};

export const ChannelFields = {
  CLASSIFICATION: 'classification',
  CHANNEL_NAME: 'channel_name',
};

export const BudgetAdjustmentOption = Object.freeze({
  DECREASE_10: 'decrease_10',
  SAME: 'same',
  INCREASE_10: 'increase_10',
  INCREASE_25: 'increase_25',
});

export const BudgetAdjustmentMultipliers = Object.freeze({
  [BudgetAdjustmentOption.DECREASE_10]: 0.9,
  [BudgetAdjustmentOption.SAME]: 1.0,
  [BudgetAdjustmentOption.INCREASE_10]: 1.1,
  [BudgetAdjustmentOption.INCREASE_25]: 1.25,
});

export const BudgetAdjustmentLabels = Object.freeze({
  [BudgetAdjustmentOption.DECREASE_10]: '-10%',
  [BudgetAdjustmentOption.SAME]: 'Same',
  [BudgetAdjustmentOption.INCREASE_10]: '+10%',
  [BudgetAdjustmentOption.INCREASE_25]: '+25%',
});

export const DurationOption = Object.freeze({
  NEXT_QUARTER: 'next_quarter',
  NEXT_6_MONTHS: 'next_6_months',
  END_OF_YEAR: 'end_of_year',
});

export const DurationLabels = Object.freeze({
  [DurationOption.NEXT_QUARTER]: 'Next Quarter',
  [DurationOption.NEXT_6_MONTHS]: 'Next 6 Months',
  [DurationOption.END_OF_YEAR]: 'End of Year',
});

export const QuickAdjustmentDefaults = Object.freeze({
  BUDGET: BudgetAdjustmentOption.SAME,
  DURATION: DurationOption.NEXT_QUARTER,
});
